import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import Dropdown from 'core/dropdown';
import ValueTypeDropdown from '../valueTypeDropdown';

export const OrderByLocationPickerContainer = styled.div`
  display: inline-flex;
`;

export const StyledValueTypeDropdown = styled(ValueTypeDropdown)`
  &&&& {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    display: flex;
    align-items: center;
    height: ${pxToRem(36)}; /** .css file replacement */
  }
`;

export const StyledCoreDropdown = styled(Dropdown)`
  &&&&&& {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }
`;
